import { useEffect } from 'react';

/**
 * While `active`, the page behind a full-screen dialog does not scroll — in iOS Safari too, where `overflow: hidden` on
 * the body is ignored for touch scrolling. The body is pinned with position: fixed at its current offset (so the page
 * does not jump), and put back, scrolled to where it was, when the lock ends. `data-agent-chat="open"` on <html> lets
 * the page hide what would cover the chat (the sticky header). Locks nest: the last one out puts the page back.
 */
let locks = 0;
let saved = null;

export function lockBody() {
  locks += 1;
  if (locks > 1) return;
  const body = document.body;
  const html = document.documentElement;
  const y = window.scrollY || window.pageYOffset || 0;
  const bar = Math.max(0, window.innerWidth - html.clientWidth);
  saved = { y, position: body.style.position, top: body.style.top, left: body.style.left, right: body.style.right, width: body.style.width, overflow: body.style.overflow, paddingRight: body.style.paddingRight, htmlOverscroll: html.style.overscrollBehavior };
  body.style.position = 'fixed';
  body.style.top = `-${y}px`;
  body.style.left = '0';
  body.style.right = '0';
  body.style.width = '100%';
  body.style.overflow = 'hidden';
  if (bar) body.style.paddingRight = `${bar}px`;
  html.style.overscrollBehavior = 'none';
  html.setAttribute('data-agent-chat', 'open');
}

export function unlockBody() {
  if (locks === 0) return;
  locks -= 1;
  if (locks > 0 || !saved) return;
  const body = document.body;
  const html = document.documentElement;
  const s = saved;
  saved = null;
  body.style.position = s.position;
  body.style.top = s.top;
  body.style.left = s.left;
  body.style.right = s.right;
  body.style.width = s.width;
  body.style.overflow = s.overflow;
  body.style.paddingRight = s.paddingRight;
  html.style.overscrollBehavior = s.htmlOverscroll;
  html.removeAttribute('data-agent-chat');
  if (s.y) { try { window.scrollTo(0, s.y); } catch (_) { /* jsdom */ } }
}

export function useBodyScrollLock(active) {
  useEffect(() => {
    if (!active) return undefined;
    lockBody();
    return unlockBody;
  }, [active]);
}
